// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__FBSMq","infoWrapper":"styles_infoWrapper__az4v4","contentWrapper":"styles_contentWrapper__xOMWF","title":"styles_title__6roKJ","description":"styles_description__AGI66","buttonWrapper":"styles_buttonWrapper__xsPRl"};
module.exports.__checksum = "8276083a77ad"
